import React, { memo, useState } from 'react';
import { Input } from 'reactstrap';

import CommonService from '../../services/commonService';
import { showMsg } from '../../services/library';
import { TM_TRADEMARK_SYMBOL } from '../../constants/messageConst';
import CustomModal from '../../components/GeneralForm/CustomModal';

const FeedbackModal = props => {
  const [body, setBody] = useState('');

  const handleChange = e => {
    const val = e.currentTarget.value;
    setBody(val);
  };

  const handleShare = async () => {
    if (body.length < 1) {
      showMsg('Please enter your feedback', 'error');
      return false;
    }
    props.handleFullLayoutLoader(true);
    try {
      const response = await CommonService.shareFeedback({ message: body });
      if (response.status) {
        setBody('');
        showMsg(response.message, 'success');
        props.toggle(); // Close the feedback modal
      } else {
        showMsg(response.errors, 'error');
      }
    } catch (error) {
      showMsg(error, 'error');
    } finally {
      props.handleFullLayoutLoader(false);
    }
  };

  return (
    <CustomModal
      isOpen={props.isOpen}
      closeClick={props.toggle}
      modalScrollable={true}
      modalSize="lg"
      saveClick={handleShare}
      isSaveButtonDisabled={body.length < 1}
      submitButtonName="Share Feedback"
      modalTitle="Feedback"
      modalBackDrop="static"
    >
      <h6>How could we improve your Autoport{TM_TRADEMARK_SYMBOL} experience?</h6>
      <Input
        type="textarea"
        className="mb-2"
        id="body"
        name="body"
        rows="9"
        maxLength="950"
        placeholder="Tell us what you think."
        value={body}
        onChange={handleChange}
      />
    </CustomModal>
  );
};

FeedbackModal.displayName = 'FeedbackModal';
export default memo(FeedbackModal);
